export function isAdminRole(roleInput: unknown): boolean {
  // Accept a string, object with name, or array of roles
  const toStr = (val: unknown): string => {
    if (!val) return "";
    if (typeof val === "string") return val;
    if (typeof val === "object") {
      try {
        // common shapes: { name: 'admin' } or { role: 'admin' }
        const obj = val as Record<string, unknown>;
        const name = obj.name ?? obj.role ?? obj.type ?? "";
        if (typeof name === "string") return name;
      } catch {}
    }
    return String(val);
  };

  const norm = toStr(roleInput).toLowerCase();
  if (!norm) return false;
  // consider any role that contains 'admin' as admin, plus common variants
  return (
    norm.includes("admin") ||
    norm === "administrator" ||
    norm === "superuser" ||
    norm === "owner" // optional: treat owner as admin in some orgs
  );
}